import { compile, ParamData, PathFunction } from 'path-to-regexp';
import { stringify as stringifyQuery } from 'query-string';

export type CompilePathParams = {
  [key: string]: string | number | string[] | number[];
};
export type CompilePathQuery = {
  [key: string]: any;
};
type CompilePathCache = {
  [key: string]: PathFunction<ParamData>;
};

const compilePathCache: CompilePathCache = {};

export function compilePath(
  pattern: string,
  params?: CompilePathParams,
  query?: CompilePathQuery,
): string {
  if (!compilePathCache[pattern]) {
    compilePathCache[pattern] = compile(pattern);
  }

  try {
    // Convert params to match ParamData type (string | string[] only)
    const convertedParams: ParamData = {};
    if (params) {
      for (const [key, value] of Object.entries(params)) {
        // Check if this parameter is a wildcard in the pattern
        const isWildcard = pattern.includes(`*${key}`);

        if (Array.isArray(value)) {
          convertedParams[key] = value.map((v) => String(v));
        } else if (isWildcard) {
          // For wildcards, convert single values to arrays
          convertedParams[key] = [String(value)];
        } else {
          convertedParams[key] = String(value);
        }
      }
    }

    const compiledPath = compilePathCache[pattern](convertedParams);
    if (query === undefined) {
      return compiledPath;
    }

    const stringifiedQuery = stringifyQuery(query);
    return stringifiedQuery ? `${compiledPath}?${stringifiedQuery}` : compiledPath;
  } catch (_error) {
    return '/';
  }
}
